import {
  OnboardingFunnelStep,
  OnboardingFunnelStepStatus,
  OnboardingFunnelStepsStatus,
} from 'src/components/enterprise/features/HomePage/types/OnboardingFunnel';

const ONBOARDING_FUNNEL_STEP_NUMBER: Record<string, number> = {
  [OnboardingFunnelStep.COMPANY_DETAILS]: 1,
  [OnboardingFunnelStep.GROUPS]: 2,
  [OnboardingFunnelStep.EMPLOYEES]: 3,
  [OnboardingFunnelStep.MANAGE_EMPLOYEES]: 4,
  [OnboardingFunnelStep.INVOICE_SETTINGS]: 5,
  [OnboardingFunnelStep.BILLING]: 6,
};

const DEFAULT_STEP_NUMBER =
  ONBOARDING_FUNNEL_STEP_NUMBER[OnboardingFunnelStep.COMPANY_DETAILS];

export function getOnboardingFunnelStepNumber(
  funnelSteps: OnboardingFunnelStepsStatus
): number {
  const inProgressStep = Object.keys(funnelSteps).find(
    (stepName) =>
      funnelSteps[stepName] === OnboardingFunnelStepStatus.IN_PROGRESS
  );

  return ONBOARDING_FUNNEL_STEP_NUMBER[inProgressStep] ?? DEFAULT_STEP_NUMBER;
}

export function getOnboardingFunnelRedirectUrl(
  corpId: string,
  funnelSteps: OnboardingFunnelStepsStatus
): string {
  const stepNumber = getOnboardingFunnelStepNumber(funnelSteps);

  return `/corporate/enterprise/${corpId}/set-up/step/${stepNumber}`;
}
